import { Trans } from '@lingui/react/macro';

import styles from './AdditionalInformation.module.css';

const links = [
  {
    label: 'AGBs',
    href: 'https://www.iwoca.de/compliance/allgemeine-geschaeftsbedingungen',
  },
  {
    label: 'Datenschutz',
    href: 'https://www.iwoca.de/compliance/datenschutzhinweis',
  },
  {
    label: 'Schufa & Crefo',
    href: 'https://www.iwoca.de/compliance/schufa-creditreform-hinweise',
  },
  { label: 'iwoca.de', href: 'https://www.iwoca.de/' },
];

const AdditionalInformation = () => {
  return (
    <footer className={styles.container}>
      <h4 className={styles.heading}>
        <Trans>Additional information:</Trans>
      </h4>
      <ul className={styles.linkList}>
        {links.map((link) => (
          <li key={link.label} className={styles.linkListItem}>
            <a href={link.href} className={styles.link}>
              {link.label}
            </a>
          </li>
        ))}
      </ul>
    </footer>
  );
};

export default AdditionalInformation;
